module.exports = __webpack_public_path__ + "img/FondMaranatha.f310fa97.jpg";